<div class="admin-sidebar-section" [class.is-expanded]="expanded" [class.is-active]="isSectionActive()">
  <button class="section-header" type="button" (click)="toggle()">
    @if (section.icon) {
      <ptl-icon [icon]="section.icon" [size]="'s'" class="section-icon"></ptl-icon>
    }
    <span class="section-title">{{ section.title }}</span>
    <ptl-icon [icon]="LucideChevronDown" [size]="'xs'" class="section-chevron" [class.rotated]="expanded"></ptl-icon>
  </button>

  <div class="section-body" [class.is-open]="expanded" [attr.aria-hidden]="!expanded" [attr.inert]="!expanded ? '' : null">
    <div class="section-body__inner">
      @if (section.showAddContent) {
        <div class="add-content-wrap">
          <button class="add-content-btn" type="button" (click)="onAddContent($event)">
            <ptl-icon [icon]="LucidePlus" [size]="'xs'"></ptl-icon>
            <span>{{ 'translations.playlist.palette.button.addContent' | transloco }}</span>
          </button>
        </div>
      }

      @if (section.rootNavItem) {
        <a
          class="nav-item"
          [routerLink]="section.rootNavItem.uri || section.rootNavItem.url || null"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          tabindex="0"
          role="button"
          (click)="onItemClick($event, section.rootNavItem)"
        >
          @if (section.rootNavItem.icon) {
            <ptl-icon [icon]="section.rootNavItem.icon" [size]="'s'" class="nav-icon"></ptl-icon>
          }
          <span class="nav-title">{{ section.rootNavItem.title }}</span>
        </a>
      }

      @for (item of section.items; track $index) {
        @if (item.expandable && item.paginatedChildren) {
          <ptl-sidebar-expandable-children
            class="sidebar-expandable-children"
            [children]="item.children"
            (childClick)="$event.event.stopPropagation()"
          ></ptl-sidebar-expandable-children>
        } @else if (item.expandable) {
          <div class="sub-group" [class.sub-group-open]="item.expanded || isItemOrChildActive(item)">
            <a
              class="nav-item"
              [routerLink]="item.url || item.uri || null"
              [routerLinkActive]="item.url || item.uri ? 'active' : ''"
              (click)="item.url || item.uri ? onItemClick($event, item) : toggleItemExpand($event, item)"
              tabindex="0"
              role="button"
            >
              @if (item.icon) {
                <ptl-icon [icon]="item.icon" [size]="'s'" class="nav-icon"></ptl-icon>
              }
              <span class="nav-title">{{ item.title }}</span>
              <ptl-icon
                [icon]="LucideChevronDown"
                [size]="'xs'"
                class="sub-chevron"
                [class.rotated]="item.expanded || isItemOrChildActive(item)"
                (click)="toggleItemExpand($event, item)"
              ></ptl-icon>
            </a>
            @if ((item.expanded || isItemOrChildActive(item)) && item.children?.length) {
              <div class="sub-children">
                @for (child of item.children; track $index) {
                  <a
                    class="nav-item nav-item--child"
                    [routerLink]="child.url || child.uri || null"
                    [routerLinkActive]="child.url || child.uri ? 'active' : ''"
                    tabindex="0"
                    role="button"
                    (click)="onItemClick($event, child)"
                  >
                    @if (child.icon) {
                      <ptl-icon [icon]="child.icon" [size]="'s'" class="nav-icon"></ptl-icon>
                    }
                    <span class="nav-title">{{ child.title }}</span>
                  </a>
                }
              </div>
            }
          </div>
        } @else {
          <a
            class="nav-item"
            [routerLink]="item.url || item.uri || null"
            [routerLinkActive]="item.url || item.uri ? 'active' : ''"
            [routerLinkActiveOptions]="{ exact: !!item.exact }"
            tabindex="0"
            role="button"
            (click)="onItemClick($event, item)"
          >
            @if (item.icon) {
              <ptl-icon [icon]="item.icon" [size]="'s'" class="nav-icon"></ptl-icon>
            }
            <span class="nav-title">{{ item.title }}</span>
          </a>
        }
      }
    </div>
  </div>
</div>
